
import { Component, Vue } from 'vue-property-decorator';

import Form3ProcessHeader from "@/components/process/Form3/components/Form3ProcessHeader.vue";
import { form3StatusInfoType } from '@/types/Information/Form3';

@Component({
    components:{
        Form3ProcessHeader
    }
})
export default class CancelSubmitForm3 extends Vue {

    stepsCompleted = {} as form3StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
